module.exports = __webpack_public_path__ + "img/goodsclose2.e2cd64d0.png";